import PageLanding from './PageLanding';

export default PageLanding;
export * from './PageLanding';
